export default __webpack_public_path__ + "maps-guides-view-annotation-marker-popup-1200-51555cc889001fe46db2a81dc234f6d8.png";